"use strict";
// mobile-menu.ts
// Beim Laden des DOMs das Menü initialisieren
document.addEventListener('DOMContentLoaded', () => {
    // Alle Links, deren Eltern-LI ein Untermenü hat
    const parentLinks = document.querySelectorAll('#mobile-menu .has-submenu > a');
    parentLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
            // parentElement ist immer ein <li>, wir casten es entsprechend
            const parentLi = link.parentElement;
            // Ist das Submenu noch geschlossen?
            if (!parentLi.classList.contains('submenu-open')) {
                event.preventDefault(); // Verhindere die erste Navigation
                parentLi.classList.add('submenu-open'); // Öffne das Untermenü
                link.setAttribute('aria-expanded', 'true'); // ARIA-Status anpassen
            }
            // Beim zweiten Klick (wenn .submenu-open bereits da ist)
            // folgt der Browser automatisch dem Link.
        });
    });
});
